

































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'lodging',
  components: {},
})
export default class LodgingPage extends Vue {
}
